// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7276":"a39c76b5","8321":"31d6cfe0"}[chunkId] + ".chunk.css";
};